export default "__VITE_ASSET__DRxTP04v__"